<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/appbindzerotrustdevice",
		    "name": "AppBind Zero Trust Device"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>AppBind: Device & Sim Binding Solution</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url('assets/images/header/app_security_banner.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60">
    <div class="container subbanner position-relative">
        <div class="row align-items-center banner">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="text-center">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                    <a class="btn-rectangle btn-transparent btn" (click)="goto()">Request A Demo</a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->


<!-- Banner Heading For Mobile -->


<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray section-pb-60 section-pt">
    <div class="container">
        <div class="row align-items-center">
            <!-- <div class="col-lg-6">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img width="100%" src="assets/images/appbind_page-icon/app_bind.webp"
                            alt="Zero Trust Device and Sim Binding solutions for Banking App">
                    </div>
                </div>
            </div> -->
            <div class="col-lg-12">
                <div class="agency-benefits">
                    <div class="content">
                        <p>
                            Financial frauds are on a steep rise which is attributed, to a large extent, to identity
                            frauds. Securing
                            user’s digital journey on mobile apps requires a more diverse approach to address these
                            threats.
                            Financial, legal, and regulatory responsibility of a safe banking experience cannot be
                            managed
                            without a comprehensive and well-developed solution that addresses risks from SMS Spoofing,
                            SIM
                            Swapping, and other means of hijacking user’s credentials.</p>
                        <p>AppBind is developed with Zero Trust principles, powered by Protectt.ai’s proprietary LSAP
                            and SSiD
                            technologies for an advanced and adaptive Device and SIM binding solution. It offers a
                            single
                            platform covering multiple touch points, creates Unique Digital Identity for every user, and
                            re-
                            verifies user at every launch. AppBind is an easy-to-deploy SDK for Android and iOS and is
                            compliant
                            with the latest RBI guidelines.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->

<div class="section-agency-benefit section-pt-60 section-pb-60" id="targetcontact">
    <div class="container d-flex">
        <div class="row">
            <div class="col-lg-6">
                <h4 class="modal-title w-100 font-weight-bold">
                    Get a quick demo today
                </h4>
                <div>
                    <p class="formparagraph1 text-left mrgntop-20">
                        Ensure a safe and secure Mobile Banking experience with our robust DEVICE and SIM Binding
                        solution. To get a demo, fill out the form below.
                    </p>
                </div>
                <div class="mt-2">
                    <form [formGroup]="demoForm" class="contactusform pt-1 pb-3">
                        <div class="row">
                          <div class="col-md-6 mb-20">
                            <label class="mb-0" for="form34">Name <span class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Name" id="form34" class="form-control validate input"
                              formControlName="name" name="name" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                              <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                              <div *ngIf="getDemoForm.name.errors.pattern">* Please enter a valid name</div>
                              <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter a valid name</div>
                            </div>
                          </div>
                      
                          <div class="col-md-6 mb-20">
                            <label class="mb-0" for="form34">Work Email <span class="text-danger">*</span></label>
                            <input type="email" placeholder="Enter Your Work Email " formControlName="email" class="form-control input"
                              id="email" name="email" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                              <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                              <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                              <div *ngIf="getDemoForm.email.errors.isValidEmail">* Please enter a business email</div>
                            </div>
                          </div>
                      
                          <div class="col-md-6 mb-20">
                            <label class="mb-0" for="form34">Phone Number <span class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34" class="form-control validate input"
                              formControlName="contactnumber" name="contactnumber"
                              [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                              <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required</div>
                              <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please enter a 10-digit Mobile Number.</div>
                            </div>
                          </div>
                      
                          <div class="col-md-6 mb-20">
                            <label class="mb-0" for="form34">Company <span class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34" class="form-control validate input"
                              formControlName="company_name" name="company_name"
                              [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                              <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                            </div>
                          </div>
                      
                          <div class="col-md-12 mb-20">
                            <label class="mb-0" for="form34">Designation <span class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Designation" id="form34" class="form-control validate input"
                              formControlName="designation" name="designation"
                              [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                              <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                              <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter a valid name</div>
                            </div>
                          </div>
                        </div>
                      
                        <div class="row">
                          <div class="col-12">
                            <button class="btn btn-unique ml-3" id="closeModal" (click)="submitDemoForm()">SUBMIT</button>
                          </div>
                        </div>
                      </form>
                      
                </div>
            </div>
            <div class="col-lg-6">
                <div class="agency-benefits">
                    <div class="content">
                        <h4 class="modal-title w-100 font-weight-bold">What to expect from our demo?</h4>
                        <p>In a demo session with our security experts, you can get a deep understanding on our
                            proprietary
                            technologies and how to easily integrate AppBind into your application.</p>
                        <ul style="list-style-type: square; padding-left: 30px;">
                            <li>Current fraud scenarios and industry challenges in the end-user authentication process
                            </li>
                            <li>How to implement latest regulatory compliances and guidelines with AppBind</li>
                            <li>Learn what value AppBind adds to your application:</li>
                            <ul style="list-style-type: circle; padding-left: 30px;">
                                <li>Get Zero trust architecture implemented</li>
                                <li>Create Unique Digital Identity for Individual Mobile App User</li>
                                <li>Eliminate Identity Thefts and SMS Spoofing frauds</li>
                                <li>Get a deep understanding of our LSAP and 3-way Hairpin Methodology through SSiD
                                    Gateway.</li>
                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- AppBind Value Proposition -->
<section class="wrapper-card">
    <div class="container-fostrap">
        <div class="content">
            <div class="container appbindcard">
                <div class="row mt-30">
                    <div class="col-lg-12">
                        <div class="section-title text-center">
                            <h2>Value Proposition</h2>
                        </div>
                    </div>
                </div>
                <!-- 1st row -->
                <div class="row mt-30">
                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/creates_unique.webp"
                                            class="og_image_url" alt="Creates Unique Digital Identity for Individual
                                        Mobile App User"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Creates Unique Digital Identity for Individual
                                    Mobile App User</h6>
                                <p class="card-text center-text">AppBind ensures that every user has a unique digital
                                    identity as per<span class="uniqueDigital dots">...</span><span
                                        class="more uniqueDigital"> RBI DPSC guidelines. This association of a unique
                                        identity to
                                        every user detects any attempt or forced entry by an attacker.
                                    </span></p>

                                <a (click)="myFunction('uniqueDigital')" id="uniqueDigital-btn" class="myBtn">Read More
                                    ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/complex_algorithm.webp" alt="Complex Algorithm of Combinations between
                                        Device, SIM & Phone No."></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Complex Algorithm of Combinations between
                                    Device, SIM & Phone No.</h6>
                                <p class="card-text center-text">To develop a unique identity for every user, AppBind
                                    <span class="uniqueDigital dots">...</span><span class="more uniqueDigital"> uses a
                                        combination of the user’s device SIM and
                                        phone number. Created by a complex
                                        algorithm, such an identity makes it extremely difficult for the attacker to
                                        discover, let alone steal it.</span>
                                </p>
                                <a (click)="myFunction('uniqueDigital')" id="uniqueDigital-btn" class="myBtn">Read
                                    More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/validate_user.webp"
                                            alt="Validate User Identity at Every Launch"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Validate User Identity at Every Launch</h6>
                                <p class="card-text center-text">AppBind is based on Zero Trust Principles. It is
                                    designed re-validate the authenticity
                                    to regularly of the user through <span class="zeroTrust dots">...</span><span
                                        class="more zeroTrust">our
                                        proprietary
                                        technology. Its advanced Device Binding and SIM Binding affirm the user’s
                                        identity every time the app is launched.</span></p>
                                <a (click)="myFunction('zeroTrust')" id="zeroTrust-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/single_platform.webp" alt="Single Platform to Orchestrate Multiple Touch
                                        Points (Mobile App, API, SMS Gateways)"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Single Platform to Orchestrate Multiple Touch
                                    Points (Mobile App, API, SMS Gateways)</h6>
                                <p class="card-text center-text">For ease of implementation<span
                                        class="singlePlatform dots">...</span><span class="more singlePlatform"> and
                                        adaptation to advanced security the AppBind SDK is a comprehensive package that
                                        consolidates with the API to communicate with SMS gateway. SMS gateway logic for
                                        secure identification of SMS; and the gateway for sending and receiving
                                        messages.</span></p>
                                <a (click)="myFunction('singlePlatform')" id="singlePlatform-btn" class="myBtn">Read
                                    More ↓</a>
                            </div>
                        </div>
                    </div>

                    <!-- 2nd row -->

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/eliminate_identity.webp" alt="Eliminate Identity Thefts and Frauds like SMS
                                        Spoofing"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Eliminate Identity Thefts and Frauds like SMS
                                    Spoofing</h6>
                                <p class="card-text center-text">The multi-way
                                    Mobile App Authentication mechanisms<span
                                        class="eliminateIdentity dots">...</span><span class="more eliminateIdentity">
                                        is used in place at different stages of user validation, designed with our
                                        trailblazing technologies and advanced device binding. It eliminates the risk of
                                        SMS Spoofing, SIM Swapping, identity theft, etc.</span></p>
                                <a (click)="myFunction('eliminateIdentity')" id="eliminateIdentity-btn"
                                    class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/step_up.webp"
                                            alt="Step Up Authentication using Tokenization"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Step Up Authentication using Tokenization</h6>
                                <p class="card-text center-text">AppBind has a unique token at every stage to help
                                    validate <span class="uniqueToken dots">...</span><span class="more uniqueToken">the
                                        SIM-User-device relationship. No static string can be
                                        crafted in advance to
                                        leverage against the authentication mechanism for identity spoofing.</span></p>
                                <a (click)="myFunction('uniqueToken')" id="uniqueToken-btn" class="myBtn">Read More
                                    ↓</a>
                            </div>
                        </div>
                    </div>

                    <!-- 3rd row -->

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/proprietary_tech.webp" alt="Proprietary Tech (LSAP, 3 Way HairPin) to
                                        Authenticate Phone Number and Looping"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Proprietary Tech (LSAP, 3 Way HairPin) to
                                    Authenticate Phone Number and Looping</h6>
                                <p class="card-text center-text">By creating a loop between <span
                                        class="lsap dots">...</span><span class="more lsap">
                                        all PSP, SMS Gateway &
                                        Mobile Device, combined with
                                        our 3-way hairpin methodology, our proprietary Loopback Short-message
                                        Authenticated Phone number (LSAP) technology establishes the relation between
                                        the user’s mobile number, mobile device, and the SIM card to avoid any
                                        discrepancy in the user validation.</span></p>
                                <a (click)="myFunction('lsap')" id="lsap-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/enhanced_user.webp" alt="Enhanced User Experience – Lesser Inputs and
                                        Advance Security"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Enhanced User Experience – Lesser Inputs and
                                    Advance Security</h6>
                                <p class="card-text center-text">AppBind is designed in a<span
                                        class="twotap dots">...</span><span class="more twotap"> simple “two-tap”
                                        authentication
                                        from the user’s end.
                                        By requiring minimum inputs, AppBind delivers world-class
                                        security at the user’s fingertips, enhancing their experience of the
                                        application.</span></p>
                                <a (click)="myFunction('twotap')" id="twotap-btn" class="myBtn">Read More ↓</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 offset-lg-4-half col-lg-3">
                        <div class="card">
                            <div class="card-body">
                                <ul>
                                    <li><img src="assets/images/appbind_page-icon/android_ios.webp"
                                            alt="Available for Android & iOS"></li>
                                </ul>
                                <h6 class="card-title font-weight-bold">Available for Android & iOS</h6>
                                <p class="card-text center-text">
                                    AppBind is an easy-to-deploy SDK, compatible with Android & iOS-based<span
                                        class="availableFor dots">...</span><span class="more availableFor">
                                        applications.
                                        It reduces the complexities or any separate procedure for different operating
                                        systems. AppBind delivers a consistent solution for both operating
                                        systems.</span></p>
                                <a (click)="myFunction('availableFor')" id="availableFor-btn" class="myBtn">Read More
                                    ↓</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-3">
                    <div class="col-md-12 text-center text-white">
                        <a class="btn-rectangle btn-transparent btn" (click)="goto(1)">Request A Demo</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start Services -->
<div class="section-agency-benefit section-pb-60 mt-50">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Need of DEVICE & SIM Binding
                    </h2>
                </div>
            </div>
        </div>
        <div class="container w-100">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <div class="service-box">
                        <div class="service-icon yellow">
                            <div class="front-content">
                                <img src="assets/images/zero-trust-binding/fraud-secenario.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-30">Fraud Scenarios

                                </h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <p style="text-transform: uppercase; text-align:center"><b>Fraud Scenarios</b>
                            </p>
                            <p class="service-description">Hijacking the user's mobile number, configuration of mobile
                                banking app by attackers or fraudulent access to bank account details are fraud
                                techniques leading to a combination of social engineering, identity theft, SIM swapping
                                and spoofing attacks.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="service-box">
                        <div class="service-icon orange">
                            <div class="front-content">
                                <img src="assets/images/zero-trust-binding/current-challenge.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-30">Current Challenges
                                </h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <p style="text-transform: uppercase; text-align:center"><b>Current Challenges</b>
                            </p>
                            <p class="service-description">Weaknesses in current systems such as lack of anomaly
                                detection in user behaviour, inadequate
                                acknowledgement during device registration, gaps in outgoing SMS validation and the
                                ever-evolving
                                Social Engineering threats.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="service-box">
                        <div class="service-icon red">
                            <div class="front-content">
                                <img src="assets/images/zero-trust-binding/solution.png"
                                    alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                                <h3 class="mt-30">Proposed Solution

                                </h3>
                            </div>
                        </div>
                        <div class="service-content">
                            <p style="text-transform: uppercase; text-align:center"><b>Proposed Solution</b>
                            </p>
                            <p class="service-description">AppBind is powered by our innovative LSAP Technology to
                                validate mobile number during
                                registration, SSiD technology for Device Binding and a robust
                                acknowledgement loop (Mobile – SMS Gateway - Server – Mobile) with our proprietary
                                hairpin
                                methodology.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<div class="container section-pb-60">
    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/appbind_page-icon/zero_trust_architecture.webp"
                        alt="Zero Trust Architecture for Enhanced Security" />
                </div>
            </div>
        </div>
        <!-- /.col-md-6 -->
        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Zero Trust Architecture for Enhanced Security</h3>
                    <p>The Zero Trust principles are based on the assumption that any request raised, within a secure
                        system could still be malicious and each request should be verified as if coming from an
                        unsecured source. In simple words, “never trust, always verify”. We have incorporated this
                        architecture with advanced Device Binding into AppBind and developed a robust acknowledgement
                        loop at every stage of Mobile App Authentication, using our proprietary technologies to make
                        sure that no anomaly in the user behaviour goes undetected.
                    </p>
                </div>
            </div>

        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img mt-15">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/appbind_page-icon/lsap_technology.webp"
                        alt="Our State-Of-The-Art LSAP Technology for Advanced User Validation" />
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Our State-Of-The-Art LSAP Technology for Advanced User Validation</h3>
                    <p>Currently, user identification is done through separate internet and SMS validations, co-related
                        to authenticate the user’s digital identity. This approach inherently assumes trust in the
                        device with the mobile app and is unable to address threats from SIM Swapping, etc. To bridge
                        the gaps in the current approach, we have developed our proprietary Loopback Short-message
                        Authenticated Phone number (LSAP) technology. LSAP is our In-house technology, that identifies,
                        on what device what mobile number is mapped to the inserted SIM. This eliminates the risk from
                        Social Engineering aspects during Mobile Banking Registration Process and MITM attacks in the
                        validation process. By creating a Robust loop between all PSP, SMS Gateway & Mobile Device,
                        combined with our 3-way hairpin methodology, an in-channel trust between device and servers is
                        established.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/appbind_page-icon/secure_sms_gateways.webp"
                        alt="Secure SMS Gateways with Our Proprietary MSAP on SSiD Technology" />
                </div>
            </div>
        </div>
        <div class="col-md-6 order-md-1">

            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Secure SMS Gateways with Our Proprietary MSAP on SSiD Technology</h3>
                    <p>The mobile number, that is the user’s identity, is currently verified in two ways- through OTP or
                        Outgoing SMS based identification. This is a highly vulnerable system prone to identity theft
                        from social engineering and SMS forwarding etc. Our solution, Multi Short-message Authenticated
                        Phone number (MSAP) on Secure SMS Identity Gateway (SSiD gateway). MSAP helps in detecting any
                        anomalies in Mobile App Authentication procedure that could be caused by an attacker. SSiD
                        avoids misuse of SMS gateways by any adversary by randomly picking a gateway from a pool of
                        gateways and maps it to a user for one session. It allows adaptive risk management by using
                        sophisticated methods like randomisation and tokenisation to secure communication to end points.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image left  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/appbind_page-icon/cloud_security_solution.webp"
                        alt="One-Stop Advanced Cloud Security Solution" />
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>One-Stop Advanced Cloud Security Solution</h3>
                    <p>Identity theft includes a range of cyber threats. AppBind has advanced Device & SIM Binding
                        powered by our Proprietary technology to eliminate Social Engineering and Spoofing aspects
                        during Mobile Banking Registration Process & avoid Cyber Frauds originating from Mobile Device &
                        Network threats. AppBind uses a Complex Algorithm of Combinations between Device, SIM & Phone
                        No., and Creates Unique Digital Identity for Every Individual Mobile App User to avoid any
                        unauthorised access. It also focuses on enhancing the user experience by requiring a simple “two
                        tap” registration process and providing maximum security.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!--  image right  -->
    <div class="row align-items-center mt-50">
        <div class="col-md-6 order-md-6 text-center">
            <div class="agency-thumb">
                <div class="thumb-img">
                    <img style="border-radius: 10px; border: 2px solid #003ac2;"
                        src="assets/images/appbind_page-icon/simplified_adaptation.webp"
                        alt="Simplified Adaptation to Advanced Security" />
                </div>
            </div>
        </div>

        <div class="col-md-6 order-md-1">
            <div class="row align-items-center h-100">
                <div class="col mt-3">
                    <h3>Simplified Adaptation to Advanced Security</h3>
                    <p>AppBind is our comprehensive security cloud solution. It is designed to be easily deployable with
                        all components required for an all-around authentication. A complete Mobile App Authentication
                        requires a specialised architecture, designed to complement, and enhance all the features in a
                        single platform. The Appbind SDK is integrated with the API to communicate with the SMS gateway,
                        SMS gateway logic for secure identification of SMS, and the gateway for sending and receiving
                        messages. It covers all the touch points of a complete acknowledgement loop at one place.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center mt-50">
        <div class="col-12 text-center text-white">
            <a class="btn-rectangle btn-transparent btn" (click)="goto(1)">Request A Demo</a>
        </div>
    </div>
</div>

<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div style="background: #163e6f" class="p-2">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()"
                    #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    Contact Us
                </h4>
                <h6 style="color: #fff">Discuss your cyber security needs</h6>
            </div>
            <div style="display: block" class="modal-header text-center">
                <p class="formparagraph1">Protectt.ai cherish your excellent decision Talk to Protectt.ai
                    to
                    learn more about how we can secure your mobile app and its data, by filling out the form below.
                    For
                    product support, please visit our contact sales page.
                </p>
            </div>
            <div class="modal-body mx-3">
                <form [formGroup]="demoForm" class="contactusform">
                    <div class="row">

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name <span
                                    class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Name" id="form34"
                                class="form-control validate input" formControlName="name" name="name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email <span
                                    class="text-danger">*</span></label>
                            <input type="email" placeholder="Enter Your Email " formControlName="email"
                                class="form-control input" id="email" name="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-4">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                                Number <span class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Phone Number" id="form34"
                                class="form-control validate input" formControlName="contactnumber" name="contactnumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company <span
                                    class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Company Name" id="form34"
                                class="form-control validate input" formControlName="company_name" name="company_name"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                            </div>
                        </div>

                        <div class="md-form mb-20 col-md-6">
                            <label class="mb-0" data-error="wrong" data-success="right" for="form34">Designation <span
                                    class="text-danger">*</span></label>
                            <input type="text" placeholder="Enter Your Designation" id="form34"
                                class="form-control validate input" formControlName="designation" name="designation"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
                            </div>
                        </div>
                    </div>

                    <div class="md-form">
                        <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
                            you?</label>
                        <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
                            class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
                    </div>
                    <div class="modal-footer d-flex justify-content-center">
                        <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close"
                            (click)="onReset()">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<section class="mediasection">
    <div class="curve">
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 section-title text-center">
                <h4 class="mt-40 mrgn">Media</h4>
            </div>
        </div>
        <div class="row bgcolor">
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.firstpost.com/business/budget-2024-expectations-will-fm-provide-further-clarity-direction-on-plans-for-digital-rupee-12061072.html"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/first_post.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Budget 2024 Expectations: Will FM provide further clarity, direction on plans for
                                digital rupee? </h6>
                            <!-- <p class="newsdate">sep 20, 2022</p> -->
                            <p>With Union Budget approaching, the talk of securing and ensuring ease of transaction in
                                Central Bank Digital Currencies (CBDCs) is further gaining ground.</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://businessindia.co/magazine/protecttai-unveils-plans-to-fight-mobile-frauds-and-cyber-threats"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/business_india.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Protectt.ai unveils plans to fight mobile frauds and cyber threats</h6>
                            <!-- <p class="newsdate">sep 19, 2022</p> -->
                            <p>Manish Mimani is a man on a mission. On the eve of Republic Day 2023, Mimani is unveiling
                                his latest initiative, ‘Protectech’. </p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.financialexpress.com/industry/technology/protectt-ai-keeping-your-mobile-data-secure-from-cyberthreats/2672717/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/financial.webp" alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent medianewsheading">
                            <h6>Protectt.ai: Keeping Your Mobile Data Secure From Cyberthreats</h6>
                            <!-- <p class="newsdate">sep 19, 2022</p> -->
                            <p>Protectt.ai has developed a plug-and-play security component which can be
                                integrated
                                with mobile apps and by default it</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://timesofindia.indiatimes.com/blogs/voices/seven-steps-towards-safe-secured-banking-app-usage/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/times_of_india.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Seven Steps Towards Safe & Secured Banking App Usage</h6>
                            <!-- <p class="newsdate">sep 7, 2022</p> -->
                            <p>Manish Mimani, Founder and CEO of Protectt.ai, shares important insights about
                                “Seven
                                steps towards safe & secured banking app usage”</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://www.expresscomputer.in/guest-blogs/securing-digital-india-must-extend-to-mobile-devices/89820/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/express.webp" alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Securing Digital India Must Extend to Mobile Devices</h6>
                            <!-- <p class="newsdate">sep 9, 2022</p> -->
                            <p>India’s ambitious objective of reaching the US$1 trillion digital economy must be
                                carefully nurtured with a strong foundation of trust</p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-12 col-lg-6 newscard mt-35">
                <a href="https://bankingfrontiers.com/protectt-ai-building-an-aatmanirbhar-bharat-with-industry-first-innovation-in-mobile-app-device-and-transaction-security/"
                    target="_blank">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 text-center">
                            <img class="newslogo" src="../../../assets/images/medianews/banking_front.webp"
                                alt="News Logo">
                        </div>
                        <div class="col-lg-8 col-md-8 newscontent">
                            <h6>Protectt.ai – Building an AatmaNirbhar Bharat With Industry First Innovation
                            </h6>
                            <!-- <p class="newsdate">sep 8, 2022</p> -->
                            <p>Here is a list of 10 important features a CISO would desire from a mobile
                                security
                                solution standpoint.</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>


        <div class="row mt-30">
            <div class="col-md-12 text-center mb-30">
                <h4><a routerLink="/media">More News &#8594;</a></h4>
            </div>
        </div>
    </div>
</section>

<div class="modal fade" id="playLandingVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md w-98vh" role="document">
        <div class="modal-content m-0 p-0 h-98vh position-relative" *ngIf="videoUrl != ''">
            <button type="button" class="btn position-top-right" data-dismiss="modal" aria-label="Close">
                <span style="color: #fff" aria-hidden="true">X</span>
            </button>
            <!-- <object data="{{getMainContentTrusted(videoUrl)}}" width="500" height="200"></object> -->
            <iframe id="video1landing" [src]='getMainContentTrusted(videoUrl)' width="100%" height="100%"
                frameborder="0" allowtransparency="true" webkitallowfullscreen mozallowfullscreen allowfullscreen
                allow="autoplay">
            </iframe>
        </div>
    </div>
</div>